import supabase from '../db'
import {writable} from 'svelte/store'

export default (updateFunc, table = '*', defaultValue = null, event = '*') => {
  const {subscribe, set} = writable(defaultValue);
  const {subscribe: loadingSubscribe, set: loadingSet} = writable(false);

  const tables = Array.isArray(table) ? table : [table];

  const update = async payload => {
    loadingSet(true);
    if (updateFunc) await updateFunc(set, supabase, payload);
    loadingSet(false);
  }

  tables.map(table => supabase
    .from(table)
    .on(event, payload => {
      if (updateFunc) update(payload);
    })
    .subscribe(),
  )

  update(null);

  const refresh = async () => {
    if (updateFunc) update(null)
  }

  return {
    subscribe,
    loading: {subscribe: loadingSubscribe},
    refresh
  }
}